const isAbsent = value => value == null;

export default isAbsent;